(function () {
  if (window.FarDtfCartPreviewLoaded) return;
  window.FarDtfCartPreviewLoaded = true;

  function number(value, fallback) {
    var parsed = Number.parseFloat(String(value || '').replace(/[^0-9.]/g, ''));
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function renderSheet(sheet) {
    if (!sheet || sheet.dataset.farRendered === 'true') return;

    var sheetWidth = number(sheet.dataset.sheetWidth, 22);
    var sheetHeight = number(sheet.dataset.sheetHeight, 36);
    var artworkWidth = number(sheet.dataset.artworkWidth, 0);
    var artworkHeight = number(sheet.dataset.artworkHeight, 0);
    var spacing = Math.max(0, number(sheet.dataset.spacing, 0.25));
    var safeMargin = Math.max(0, number(sheet.dataset.safeMargin, 0.25));
    var requested = Math.max(0, Math.floor(number(sheet.dataset.requestedQuantity, 0)));
    var artworkUrl = sheet.dataset.artworkUrl || '';
    var safe = sheet.querySelector('[data-far-cart-sheet-safe]');

    if (!artworkUrl || artworkWidth <= 0 || artworkHeight <= 0) return;

    var safeWidth = Math.max(0, sheetWidth - safeMargin * 2);
    var safeHeight = Math.max(0, sheetHeight - safeMargin * 2);
    var columns = Math.max(0, Math.floor((safeWidth + spacing) / (artworkWidth + spacing)));
    var rows = Math.max(0, Math.floor((safeHeight + spacing) / (artworkHeight + spacing)));
    var capacity = columns * rows;
    var visible = Math.min(requested || capacity, capacity, 80);

    sheet.style.aspectRatio = sheetWidth + ' / ' + sheetHeight;
    if (safe) {
      safe.style.left = (safeMargin / sheetWidth * 100) + '%';
      safe.style.top = (safeMargin / sheetHeight * 100) + '%';
      safe.style.width = (safeWidth / sheetWidth * 100) + '%';
      safe.style.height = (safeHeight / sheetHeight * 100) + '%';
    }

    for (var index = 0; index < visible; index += 1) {
      var column = index % columns;
      var row = Math.floor(index / columns);
      var tile = document.createElement('img');
      tile.className = 'far-cart-sheet__tile';
      tile.src = artworkUrl;
      tile.alt = '';
      tile.loading = 'lazy';
      tile.style.left = ((safeMargin + column * (artworkWidth + spacing)) / sheetWidth * 100) + '%';
      tile.style.top = ((safeMargin + row * (artworkHeight + spacing)) / sheetHeight * 100) + '%';
      tile.style.width = (artworkWidth / sheetWidth * 100) + '%';
      tile.style.height = (artworkHeight / sheetHeight * 100) + '%';
      sheet.appendChild(tile);
    }

    sheet.dataset.farRendered = 'true';
    sheet.dataset.farCapacity = String(capacity);
  }

  function renderAll(scope) {
    (scope || document).querySelectorAll('[data-far-cart-sheet]').forEach(renderSheet);
  }

  function start() {
    renderAll(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-far-cart-sheet]')) renderSheet(node);
          renderAll(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
